import { FC, PropsWithChildren } from 'react';
import { UseUserContext } from '../../bo-kit/components/AuthorizedLayout/hooks/useUser';
import { useGetUserProfileQuery } from '@/transport/gatewayApi';

export const UseUserContextProvider: FC<PropsWithChildren> = ({ children }) => {
    const { data: userData } = useGetUserProfileQuery();
    return <UseUserContext.Provider value={userData || null}>{children}</UseUserContext.Provider>;
};
